import Vue from 'vue'
import localePath from '@/infrastructure/router/locale-path'
import localeLocation from '@/infrastructure/router/locale-location'

Vue.use(localePath)
Vue.use(localeLocation)
